import { useRepositoryMutation } from '@mews-commander/data-access';
import { WithEnterpriseId } from '@mews-commander/types';
import { IntegrationCreateFormProps } from '../common';
import { UpdateFormValues } from './schema';

export const useUpdateHandler = (id: string) => {
    const { mutate, isPending } = useRepositoryMutation('mewsBiIntegration', 'update', {
        transformParams: (values: UpdateFormValues & WithEnterpriseId) => ({
            ...values,
            id,
            isEnabled: values.isEnabled.includes('true'),
        }),
        invalidateQueries: { mewsBiIntegration: ['get'] },
    });

    const handleSubmit: IntegrationCreateFormProps<UpdateFormValues>['handleSubmit'] = (values, onSuccess) => {
        mutate(values, {
            onSuccess,
        });
    };

    return { handleSubmit, isPending };
};
